<div
  class="sensor-value"
  [class.ghost]="ghost()"
  [class.asHeader]="asHeader()"
  [class.critical]="!isInactive() && isCritical()"
  [class.warning]="isWarning()"
  [class.inactive]="isInactive()"
  [class.nodata]="isWorking() && noData(telemetrySafe)"
  [class.desktop]="isDesktop()"
>
  <div [class.german]="IsGerman()">
    @if (!IsInletOutletTemp()) {
      <div class="sensor-value-data data">
        @if (isWorking() && !isInactive()) {
          <i
            nz-icon
            nzType="icons:status-check"
            class="svg-icon mini-svg-icon left-icon"
            [class.fillgreen]="asHeader() && !noData(telemetrySafe)"
          ></i>
        }
        @if (!isInactive() && isWarning()) {
          <i
            nz-icon
            nzType="icons:status-exclamation-octagon"
            class="svg-icon mini-svg-icon left-icon"
            [class.fillyellow]="!asHeader() && !asHealth()"
          ></i>
        }
        @if (isInactive()) {
          <i
            nz-icon
            nzType="icons:cross-circle"
            class="svg-icon mini-svg-icon left-icon"
            [class.fillgrey]="!asHeader() && !noData(telemetrySafe)"
          ></i>
        }
        @if (!isInactive() && isCritical() && OutletTempString()) {
          <i
            nz-icon
            nzType="icons:status-exclamation-triangle"
            class="svg-icon mini-svg-icon left-icon"
            [class.fillred]="!asHeader() && !asHealth()"
            [class.fillwhite]="asHeader() || asHealth()"
          ></i>
        }
        @if (noData(telemetrySafe)) {
          {{ i18n.langString("no_data") }}
        } @else {
          @if (
            valueType !== "minmax" &&
            valueType !== "boolean" &&
            valueType !== "flag" &&
            !telemetrySafe?.inactive
          ) {
            <span>{{ i18n.parse(Title()) }}</span>
            @if (!isSteamTrap()) {
              <span [class.margin-span]="!!Title()">{{ valStr }}</span>
            }
          }

          @if (valueType === "minmax") {
            <span>{{ i18n.parse(Title()) }}</span>
            @if (!isSteamTrap() && !batteryCurrentVal()) {
              {{ " " }}{{ valStr.min }} -
              <span [class.margin-span]="!!Title()">{{ valStr.max }}</span>
            }
            @if (!isSteamTrap() && batteryCurrentVal()) {
              {{ " " }}{{ valStr.min }}
            }
          }

          @if (
            (valueType === "boolean" || valueType === "flag") &&
            !telemetrySafe?.inactive
          ) {
            <span>{{ i18n.parse(Title()) }}</span>
          }

          @if (telemetrySafe?.inactive) {
            <span class="tile-title">{{
              i18n.langString("inactive_status")
            }}</span>
          }
        }
      </div>
    }

    @if (IsInletOutletTemp()) {
      <div class="sensor-value-data data inlet-outlet-data">
        <div class="sensor-value-data-row">
          @if (!InletWarning() && !InletCritical()) {
            <i
              nz-icon
              nzType="icons:status-check"
              class="svg-icon mini-svg-icon left-icon"
              [class.fillgreen]="!asHeader() && !noData(telemetrySafe)"
            ></i>
          }
          @if (InletWarning() && !InletCritical()) {
            <i
              nz-icon
              nzType="icons:status-exclamation-octagon"
              class="svg-icon mini-svg-icon left-icon"
              [class.fillyellow]="!asHeader() && !asHealth()"
            ></i>
          }
          @if (InletCritical()) {
            <i
              nz-icon
              nzType="icons:status-exclamation-triangle"
              class="svg-icon mini-svg-icon left-icon"
              [class.fillred]="!asHeader() && !asHealth()"
              [class.fillwhite]="asHeader() || asHealth()"
            ></i>
          }

          @if (noData(telemetrySafe)) {
            {{ i18n.langString("no_data") }}
          } @else {
            <span
              >{{ i18n.langString("mean_inlet") }}:
              {{ InletTempString() }}</span
            >
          }
        </div>

        <div class="sensor-value-data-row">
          @if (!OutletWarning() && !OutletCritical() && OutletTempString()) {
            <i
              nz-icon
              nzType="icons:status-check"
              class="svg-icon mini-svg-icon left-icon"
              [class.fillgreen]="!asHeader() && !noData(telemetrySafe)"
            ></i>
          }
          @if (OutletWarning() && !OutletCritical()) {
            <i
              nz-icon
              nzType="icons:status-exclamation-octagon"
              class="svg-icon mini-svg-icon left-icon"
              [class.fillyellow]="!asHeader() && !asHealth()"
            ></i>
          }
          @if (OutletCritical() && OutletTempString()) {
            <i
              nz-icon
              nzType="icons:status-exclamation-triangle"
              class="svg-icon mini-svg-icon left-icon"
              [class.fillred]="!asHeader() && !asHealth()"
              [class.fillwhite]="asHeader() || asHealth()"
            ></i>
          }
          @if (noData(telemetrySafe) || !OutletTempString()) {
            <i
              nz-icon
              nzType="icons:cross-circle"
              class="svg-icon mini-svg-icon left-icon"
            ></i>
            <span>{{ i18n.langString("sensor_checked") }}</span>
          } @else {
            <span
              >{{ i18n.langString("mean_outlet") }}:
              {{ OutletTempString() }}</span
            >
          }
        </div>
      </div>
    }

    <div class="sensor-value-time detail-bold">
      <i
        nz-icon
        nzType="icons:refresh"
        class="svg-icon mini-svg-icon"
        [class.fillblackcoral]="
          !isCritical() && !isWarning() && !asHeader() && !noData(telemetrySafe)
        "
        [class.fillwhite]="isCritical()"
      ></i>
      @if (validTimeValue(timestamp)) {
        <span class="align-right">
          {{ i18n.langString("ago1") }}{{ minutesToNow(timestamp)
          }}{{ i18n.langString("ago2") }}
        </span>
      } @else {
        <span class="align-right">{{ i18n.langString("never_checked") }}</span>
      }
    </div>
  </div>

  @if (IsBattery() && !asHeader()) {
    <div
      #battery
      class="battery-indicator"
      [class.nodata]="noData(telemetrySafe)"
    >
      @for (blob of Range(Numblobs); track blob) {
        <div class="charge-blob" [class.filled]="blob <= ChargingStatus"></div>
      }
    </div>
  }

  @if (lineColor()) {
    <div [class]="'line ' + lineColor()"></div>
  }
</div>
